import { facilityService } from "client-app-core";
import { selectedContextSelector } from "orion-components/ContextPanel/Selectors";

// Internal action creators for syncing floor plan state
// These only update selectedFloor without touching persisted state
export const syncSelectFloorPlan = floorPlan => ({
	type: "FLOOR_PLAN_SELECT",
	payload: { floorPlan }
});

export const syncClearFloorPlan = () => ({
	type: "FLOOR_PLAN_CLEAR"
});

export const setFloorOrder = floorPlans => {
	return (dispatch, getState) => {
		const { entity } = selectedContextSelector(getState());
		facilityService.reorderFloorplans(entity.id, floorPlans, err => {
			if (err) {
				console.log("ERROR:", err);
			}
		});
	};
};
